import { render, staticRenderFns } from "./OptionsDisplay.vue?vue&type=template&id=4ddf4c1c&"
import script from "./OptionsDisplay.vue?vue&type=script&lang=js&"
export * from "./OptionsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports